import { MapData } from '../mapData/mapData';
import { useQuery } from 'react-query';
import axiosWrapper from '../../../../helpers/axiosWrapper';

const useCountriesGeoData = (
  mapUrl = 'https://em-frontend-assets.airtrfx.com/assets/map-tiles/world-countries-usa-states.json',
  axiosWrapperOptions = {}
) => {
  return useQuery(
    mapUrl,
    () =>
      axiosWrapper(
        {
          method: 'get',
          url: mapUrl
        },
        {
          resource: 'INTEGRATION__GET__MAPS',
          meta: 'InteractiveMapUseQuery',
          // // Static retry added until prePopulation by props arrives
          integrationSettings: {
            csrRetries: 3,
            ssrRetries: 3
          },
          ...axiosWrapperOptions
        }
      ).then((response) => response.data as MapData),
    {
      refetchOnWindowFocus: false,
      staleTime: 86400000,
      retry: false
    }
  );
};

export default useCountriesGeoData;
